import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	companies: [],
};

// active account slice
export const allCompaniesSlice = createSlice({
	name: 'companies',
	initialState,
	reducers: {
		setAllCompanies: (state, action) => {
			state.companies = action.payload;
		},
		setCompaniesList: (state, action) => {
			state.companiesList = action.payload;
		},
	},
});

export const {
	setAllCompanies,
	setCompaniesList
} = allCompaniesSlice.actions;

export default allCompaniesSlice.reducer;
